import { FC } from "react"
import { SafetiesAnswer } from "../../../module/safeties/containers/answer"

export const SafetiesAnswerPage: FC = () => <SafetiesAnswer />
